export default "__VITE_PUBLIC_ASSET__b51fd88c__"